import React from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';

import { TIMEZONES } from 'appConstants';

interface TimezonePickerProps extends SelectProps<string> {}

const TimezonePicker = (props: TimezonePickerProps) => {
  const { disabled, onChange, style, value } = props;

  return (
    <Select
      showSearch
      value={value}
      placeholder="Pick Timezone"
      optionFilterProp="children"
      onChange={onChange}
      filterOption={(input, option) =>
        option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      style={{ flex: '1 0 300px', ...style }}
      disabled={disabled}
    >
      {TIMEZONES.map(timezone => (
        <Select.Option key={timezone.value} value={timezone.value}>
          ({timezone.offsetLabel}) {timezone.label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default TimezonePicker;
